const baseTools = {
  shuffle (arr) {
    for (let i = 1; i < arr.length; i++) {
      const random = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[random]] = [arr[random], arr[i]]
    }
    return arr
  },
  addOreder (ID, GOODS, COUNT, UNIT) {
    const timeData = new Date()
    const addTime = timeData.getFullYear().toString() + timeData.getMonth().toString() + timeData.getDate().toString()
    const newObj = {
      ID: ID,
      GOODS: GOODS,
      COUNT: COUNT,
      UNIT: UNIT,
      ADDTIME: addTime
    }
    return newObj
  }

}
export default baseTools
